import { History } from "history";

import {
  ADD_SUBJECT_NOTE,
  ADD_SUBJECT_NOTE_ERROR,
  ADD_SUBJECT_NOTE_SUCCESS,
  AddSubjectNoteAction,
  AddSubjectNoteErrorAction,
  AddSubjectNoteSuccessAction,
  DELETE_SUBJECT_NOTE,
  DELETE_SUBJECT_NOTE_CONSENT,
  DELETE_SUBJECT_NOTE_ERROR,
  DELETE_SUBJECT_NOTE_SUCCESS,
  DOWNLOAD_SUBJECT_NOTE,
  DOWNLOAD_SUBJECT_NOTE_ERROR,
  DOWNLOAD_SUBJECT_NOTE_SUCCESS,
  DeleteSubjectNoteAction,
  DeleteSubjectNoteConsentAction,
  DeleteSubjectNoteErrorAction,
  DeleteSubjectNoteSuccessAction,
  DownloadSubjectNoteAction,
  DownloadSubjectNoteErrorAction,
  DownloadSubjectNoteSuccessAction,
  GET_SUBJECT_NOTE,
  GET_SUBJECT_NOTES,
  GET_SUBJECT_NOTES_ERROR,
  GET_SUBJECT_NOTES_SUCCESS,
  GET_SUBJECT_NOTE_ERROR,
  GET_SUBJECT_NOTE_SUCCESS,
  GetSubjectNoteAction,
  GetSubjectNoteErrorAction,
  GetSubjectNoteSuccessAction,
  GetSubjectNotesAction,
  GetSubjectNotesErrorAction,
  GetSubjectNotesSuccessAction,
  TOGGLE_ADD_EDIT_SUBJECT_NOTE_MODAL,
  TOGGLE_SUBJECT_NOTE_STATE,
  TOGGLE_SUBJECT_NOTE_STATE_CONSENT,
  TOGGLE_SUBJECT_NOTE_STATE_ERROR,
  TOGGLE_SUBJECT_NOTE_STATE_SUCCESS,
  ToggleAddEditSubjectNoteModalAction,
  ToggleSubjectNoteStateAction,
  ToggleSubjectNoteStateConsentAction,
  ToggleSubjectNoteStateErrorAction,
  ToggleSubjectNoteStateSuccessAction,
  UPDATE_SUBJECT_NOTE,
  UPDATE_SUBJECT_NOTE_ERROR,
  UPDATE_SUBJECT_NOTE_SUCCESS,
  UPLOAD_SUBJECT_NOTE,
  UPLOAD_SUBJECT_NOTE_ERROR,
  UPLOAD_SUBJECT_NOTE_SUCCESS,
  UpdateSubjectNoteAction,
  UpdateSubjectNoteErrorAction,
  UpdateSubjectNoteSuccessAction,
  UploadSubjectNoteAction,
  UploadSubjectNoteErrorAction,
  UploadSubjectNoteSuccessAction,
} from "./actionTypes";
import {
  CreateSubjectNoteRequest,
  SubjectNoteDto,
  PaginateQuery,
  UpdateSubjectNoteRequest,
} from "../../interfaces";
import { Paginated } from "../../models";
import { MediaDto } from "../../interfaces/media";

//#region Get SubjectNotes

export const getSubjectNotes = (
  request: PaginateQuery,
  history: History
): GetSubjectNotesAction => {
  return {
    type: GET_SUBJECT_NOTES,
    payload: { request, history },
  };
};

export const getSubjectNotesSuccess = (
  response: Paginated<SubjectNoteDto>
): GetSubjectNotesSuccessAction => {
  return {
    type: GET_SUBJECT_NOTES_SUCCESS,
    payload: response,
  };
};

export const getSubjectNotesError = (
  error: any
): GetSubjectNotesErrorAction => {
  return {
    type: GET_SUBJECT_NOTES_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Subject Note

export const getSubjectNote = (
  id: string,
  history: History
): GetSubjectNoteAction => {
  return {
    type: GET_SUBJECT_NOTE,
    payload: { id, history },
  };
};

export const getSubjectNoteSuccess = (
  response: SubjectNoteDto
): GetSubjectNoteSuccessAction => {
  return {
    type: GET_SUBJECT_NOTE_SUCCESS,
    payload: response,
  };
};

export const getSubjectNoteError = (error: any): GetSubjectNoteErrorAction => {
  return {
    type: GET_SUBJECT_NOTE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Add Subject Note

export const addSubjectNote = (
  request: CreateSubjectNoteRequest,
  history: History
): AddSubjectNoteAction => {
  return {
    type: ADD_SUBJECT_NOTE,
    payload: { request, history },
  };
};

export const addSubjectNoteSuccess = (): AddSubjectNoteSuccessAction => {
  return {
    type: ADD_SUBJECT_NOTE_SUCCESS,
    payload: null,
  };
};

export const addSubjectNoteError = (error: any): AddSubjectNoteErrorAction => {
  return {
    type: ADD_SUBJECT_NOTE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Update Subject Note

export const updateSubjectNote = (
  id: string,
  request: UpdateSubjectNoteRequest,
  history: History
): UpdateSubjectNoteAction => {
  return {
    type: UPDATE_SUBJECT_NOTE,
    payload: { id, request, history },
  };
};

export const updateSubjectNoteSuccess = (): UpdateSubjectNoteSuccessAction => {
  return {
    type: UPDATE_SUBJECT_NOTE_SUCCESS,
    payload: null,
  };
};

export const updateSubjectNoteError = (
  error: any
): UpdateSubjectNoteErrorAction => {
  return {
    type: UPDATE_SUBJECT_NOTE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Delete Subject Note

export const deleteSubjectNoteConsent = (
  id: string
): DeleteSubjectNoteConsentAction => {
  return {
    type: DELETE_SUBJECT_NOTE_CONSENT,
    payload: id,
  };
};

export const deleteSubjectNote = (
  id: string,
  history: History
): DeleteSubjectNoteAction => {
  return {
    type: DELETE_SUBJECT_NOTE,
    payload: { id, history },
  };
};

export const deleteSubjectNoteSuccess = (): DeleteSubjectNoteSuccessAction => {
  return {
    type: DELETE_SUBJECT_NOTE_SUCCESS,
    payload: null,
  };
};

export const deleteSubjectNoteError = (
  error: any
): DeleteSubjectNoteErrorAction => {
  return {
    type: DELETE_SUBJECT_NOTE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Toggle Subject Note State

export const toggleSubjectNoteStateConsent = (
  id: string
): ToggleSubjectNoteStateConsentAction => {
  return {
    type: TOGGLE_SUBJECT_NOTE_STATE_CONSENT,
    payload: id,
  };
};

export const toggleSubjectNoteState = (
  id: string,
  history: History
): ToggleSubjectNoteStateAction => {
  return {
    type: TOGGLE_SUBJECT_NOTE_STATE,
    payload: { id, history },
  };
};

export const toggleSubjectNoteStateSuccess = (
  id: string
): ToggleSubjectNoteStateSuccessAction => {
  return {
    type: TOGGLE_SUBJECT_NOTE_STATE_SUCCESS,
    payload: { id },
  };
};

export const toggleSubjectNoteStateError = (
  error: any
): ToggleSubjectNoteStateErrorAction => {
  return {
    type: TOGGLE_SUBJECT_NOTE_STATE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Upload Subject Note

export const uploadSubjectNote = (
  file: File,
  id?: string | null
): UploadSubjectNoteAction => {
  return {
    type: UPLOAD_SUBJECT_NOTE,
    payload: { file, id },
  };
};

export const uploadSubjectNoteSuccess = (
  media: MediaDto
): UploadSubjectNoteSuccessAction => {
  return {
    type: UPLOAD_SUBJECT_NOTE_SUCCESS,
    payload: media,
  };
};

export const uploadSubjectNoteError = (
  error: any
): UploadSubjectNoteErrorAction => {
  return {
    type: UPLOAD_SUBJECT_NOTE_ERROR,
    payload: error,
  };
};
//#endregion

//#region add edit subject note modal
export const toggleAddEditSubjectNoteModal =
  (): ToggleAddEditSubjectNoteModalAction => {
    return {
      type: TOGGLE_ADD_EDIT_SUBJECT_NOTE_MODAL,
      payload: null,
    };
  };
//#endregion

//#region download note file
export const downloadNoteFile = (id: string): DownloadSubjectNoteAction => {
  return {
    type: DOWNLOAD_SUBJECT_NOTE,
    payload: { id },
  };
};

export const downloadNoteFileSuccess = (
  response: any
): DownloadSubjectNoteSuccessAction => {
  return {
    type: DOWNLOAD_SUBJECT_NOTE_SUCCESS,
    payload: response,
  };
};

export const downloadNoteFileError = (
  error: any
): DownloadSubjectNoteErrorAction => {
  return {
    type: DOWNLOAD_SUBJECT_NOTE_ERROR,
    payload: error,
  };
};
//#endregion
